import { Box, Button, Heading, Icon, SimpleGrid, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeProvider';
import { useProfile } from '@partiu/ui/contexts/ProfileProvider';
import {
  FaRegUser,
  FaRegHeart,
  FaRegClock,
  FaRegClipboard,
  FaRegEnvelope,
  FaRegUserCircle,
  FaRegHandshake,
  FaRegFileAlt,
  FaShieldAlt,
} from 'react-icons/fa';

const ProfileLink = ({ name, color, to, icon }: { color: string; name: string; to: string; icon: any }) => {
  const navigate = useNavigate();
  return (
    <Box
      as="button"
      onClick={() => navigate(to)}
      borderRadius="lg"
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      alignItems={'flex-start'}
      backgroundColor="white"
      overflow="hidden"
      height="110px"
      padding="20px"
      boxShadow={'2px 2px 6px 0px #0000002E'}
      width="100%"
    >
      <Icon color={color} as={icon} boxSize={6} marginBottom="10px" />
      <Heading color="#292927" fontWeight={'500'} textAlign={'left'} fontSize="16px">
        {name}
      </Heading>
    </Box>
  );
};

export function ProfileLinks() {
  const { profile, logout } = useProfile();
  const { id, metadata, colors, getValidSubscriptions } = useTheme();
  const subscriptions = getValidSubscriptions(profile || undefined);

  if (!profile) return <></>;

  return (
    <VStack w={'100%'}>
      <SimpleGrid columns={[2, 4]} spacing={3} width="100%">
        <ProfileLink color={colors.primaryColor} name="Meus Dados" to="meus-dados" icon={FaRegUser} />
        <ProfileLink color={colors.primaryColor} name="Favoritos" to={`/favoritos`} icon={FaRegHeart} />
        <ProfileLink color={colors.primaryColor} name="Histórico de uso" to={'/historico'} icon={FaRegClock} />
        {!metadata?.removeplan && (
          <ProfileLink name="Planos" color={colors.primaryColor} to={`planos`} icon={FaRegClipboard} />
        )}
        <ProfileLink color={colors.primaryColor} name="Fale Conosco" to="/contato" icon={FaRegEnvelope} />
        {subscriptions.length > 0 && subscriptions[0].active && (
          <ProfileLink
            color={colors.primaryColor}
            name="Gerenciar Dependentes"
            to="dependentes"
            icon={FaRegUserCircle}
          />
        )}
        <ProfileLink color={colors.primaryColor} name="Seja Parceiro" to="/parcerias" icon={FaRegHandshake} />
        <ProfileLink color={colors.primaryColor} name="Termos de Uso" to="/legal/termos-de-uso" icon={FaRegFileAlt} />
        <ProfileLink
          color={colors.primaryColor}
          name="Política De Privacidade"
          to="/legal/politica-de-privacidade"
          icon={FaShieldAlt}
        />
        {/*
        <ProfileLink color={colors.primaryColor} name="Telemedicina" to="/telemedicina" icon={FaUserDoctor} />
         */}
      </SimpleGrid>

      <Button variant={''} marginTop={25} onClick={logout}>
        <Heading color="#747474" fontWeight={'600'} fontFamily={'Glory'} fontSize={'18px'}>
          SAIR
        </Heading>
      </Button>
    </VStack>
  );
}
